import React, { memo } from 'react';
import { useLocalTimestamp } from '../../hooks';
import { CommunicationIcon } from '../CommunicationIcon/CommunicationIcon';
import type { CommunicationMode } from '../../containers/CommentList/CommentList.types';
import type { IconOverrides } from '../../types/IconOverrides';

type ShowEditedAtType = 'none' | 'edited' | 'editedAtTimestamp';

interface CommentMetadataProps {
  createdAt: string;
  editedAt?: string;
  section?: string;
  showEditedAt?: ShowEditedAtType;
  communicationMode?: CommunicationMode;
  iconOverrides?: IconOverrides;
}

const CommentMetadataComponent: React.FC<CommentMetadataProps> = ({
  createdAt,
  editedAt,
  section,
  showEditedAt = 'edited',
  communicationMode,
  iconOverrides
}) => {
  const localTimestamp = useLocalTimestamp(createdAt);
  const editedTimestamp = useLocalTimestamp(editedAt || createdAt);

  const renderEditedInfo = () => {
    if (!editedAt || createdAt === editedAt) return null;

    switch (showEditedAt) {
      case 'none':
        return null;
      case 'edited':
        return <span className="comment-text__edited"> (edited)</span>;
      case 'editedAtTimestamp':
        return (
          <span className="comment-text__edited"> ({editedTimestamp})</span>
        );
      default:
        return <span className="comment-text__edited"> </span>;
    }
  };
  return (
    <div className="comment-text__timestamp-container">
      <p className="comment-text__timestamp">
        <CommunicationIcon
          communicationMode={communicationMode}
          iconOverrides={iconOverrides}
        />
        {localTimestamp}
        {renderEditedInfo()}
      </p>
      {section && (
        <span className="comment-text__section">
          <span>Section: &nbsp;</span>
          <span className="comment-text__section-value">{section}</span>
        </span>
      )}
    </div>
  );
};

export const CommentMetadata = memo(CommentMetadataComponent);
